<template>
  <div>
    <div class="header header-contractor">
      <h1>
        <transition
          mode="out-in"
          enter-active-class="animated fadeIn"
          leave-active-class="animated faster fadeOut"
        >
          <i class="fas fa-arrow-left" id="arrow" @click="back"></i>
        </transition>
        Podaci o serviseru
        <transition
          mode="out-in"
          enter-active-class="animated fadeIn"
          leave-active-class="animated faster fadeOut"
        >
          <i class="badge--mod far fas fa-toolbox"></i>
        </transition>
      </h1>
      <!-- <h2>{{ communityType }}</h2> -->
    </div>
    <div class="body-wrapper">
      <modal-confirm-action
        v-if="showDeleteContactModal"
        @close="showDeleteContactModal = false"
        @confirm="deleteContractorContact"
        :isLoading="deleteLoading"
        title="Brisanje kontakta"
      >
        <div>Da li ste sigurni da želite da obrišete kontakt:</div>
        <div>{{ contactToDelete.name }}</div>
      </modal-confirm-action>
      <div class="left-column">
        <div class="box">
          <div class="title-wrapper main-title flex">
            <b class="title">Informacije</b>
            <i
              class="fas fa-pen"
              @click="showModal('ModalContentEditContractor')"
            ></i>
          </div>

          <spinner :size="20" line-fg-color="#00796b" v-if="loadingBasicInfo" />
          <div class="info-box">
            <div class="left-column" v-if="!loadingBasicInfo">
              <div class="div-description single-info">
                <small class="label">Naziv</small>
                <h4 class="value">{{ contractor.name }}</h4>
              </div>
              <div class="fullname single-info">
                <small class="label">Adresa</small>
                <h4 class="value">
                  {{ contractor.address.street_name }}
                  {{ contractor.street_number }},
                  {{ contractor.address.municipality.name }}
                </h4>
              </div>
              <div class="fullname single-info">
                <small class="label">Opis</small>
                <h4 class="value">
                  {{
                    contractor.description == '' ? '/' : contractor.description
                  }}
                </h4>
              </div>
              <div class="fullname single-info">
                <small class="label">Web site</small>
                <a
                  v-if="contractor.web_site"
                  class="value"
                  target="_blank"
                  :href="
                    isValidWebsite(contractor.web_site)
                      ? contractor.web_site
                      : 'http://' + contractor.web_site
                  "
                >
                  {{ contractor.web_site }}
                </a>
                <h4 v-else class="value">
                  /
                </h4>
              </div>
              <div class="fullname single-info">
                <small class="label">Kategorija</small>
                <h4 class="value">
                  {{
                    contractor.infrastructure_type == ''
                      ? '/'
                      : contractor.infrastructure_type
                  }}
                </h4>
              </div>
              <div class="fullname single-info">
                <small class="label">Matični broj</small>
                <h4 class="value">
                  {{ contractor.mb }}
                </h4>
              </div>
              <div class="fullname single-info">
                <small class="label">Pib</small>
                <h4 class="value">
                  {{ contractor.pib }}
                </h4>
              </div>

              <div class="fullname single-info">
                <small class="label">Broj računa</small>
                <h4 class="value">
                  {{ contractor.account_number }}
                </h4>
              </div>
            </div>
          </div>
        </div>
        <div class="box invoices contacts">
          <div class="title-wrapper">
            <b class="title">Kontakti</b>
            <a class="btn" @click="openAddContractorContact">
              <i class="fas fa-plus"></i>
            </a>
          </div>
          <spinner :size="20" line-fg-color="#00796b" v-if="loadingBasicInfo" />
          <div class="table" v-if="!loadingBasicInfo">
            <div v-if="contractor.contacts.length == 0">
              Ne postoje kontakti za servisera
            </div>
            <div ref="rows" class="rows">
              <div
                class="row"
                v-for="row in contractor.contacts"
                :key="row.id"
                :class="{
                  'expanded-content': row.isExpanded
                }"
              >
                <div class="parent">
                  <div class="column more" style="flex: 1">
                    <a class="more-btn" @click="toggleItems(row)">
                      <i class="fas fa-chevron-right"></i>
                    </a>
                  </div>
                  <div class="column" style="flex: 4">
                    {{ row.name }}
                  </div>
                  <div class="column actions" style="flex: 4">
                    <a class="btn" @click="openEditContact(row)">
                      <i class="fas fa-pen"></i>
                    </a>
                    <a class="btn" @click="openDeleteContact(row)">
                      <i class="fas fa-minus"></i>
                    </a>
                  </div>
                </div>
                <div class="items">
                  <div class="">
                    <div v-if="row.description" class="row-desc">Opis</div>
                    <div v-if="row.description" class="column">
                      {{ row.description }}
                    </div>
                    <div class="row-desc">Telefon</div>
                    <div class="column">{{ row.phone ? row.phone : '/' }}</div>
                    <div class="row-desc" v-if="row.email">Email</div>
                    <a
                      v-if="row.email"
                      class="column"
                      :href="'mailto: ' + row.email"
                      >{{ row.email }}</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right-column">
        <div class="box transactions">
          <div class="title-wrapper">
            <b class="title">Tiketi</b>
          </div>
          <div class="table table-contractor-tickets">
            <spinner
              class="spinner"
              line-fg-color="#00796b"
              :size="100"
              :line-size="6"
              v-if="loading"
            ></spinner>
            <div v-if="!loadingBasicInfo" class="transactions-table">
              <data-table
                :columns="table.tableColumns"
                :tableData="contractor.tickets"
                :options="table.tableOptions"
                :slotNamePriority="'priority_id'"
                :slotNameStatus="'current_status'"
                :slotNamePrivacy="'privacy'"
                :slotDate="'timestamp'"
                :hideDefaultSort="true"
              ></data-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DataTable from '@/components/community/Table';
import { mapState, mapActions, mapMutations } from 'vuex';
import { financesInstance } from '@/axios/axios.js';
import axios from '@/axios/axios.js';
import { utilService } from '@/util/UtilService.js';
import { addSeparatorMixin } from '@/mixins/mixins.js';
import modalConfirmAction from '@/components/modal/ModalConfirmAction.vue';
import checkbox from '@/components/common/Checkbox.vue';
import uploadButton from '@/components/modal/modal-content/ModalContentPollUploadButton.vue';

export default {
  name: 'CommunityFinancesMember',
  components: {
    DataTable,
    modalConfirmAction
  },
  mixins: [addSeparatorMixin],
  data() {
    return {
      // contractor: null,
      loadingBasicInfo: true,
      table: {
        tableColumns: [
          'priority_id',
          'communityName',
          'title',
          'description',
          'current_status',
          'privacy'
        ],
        tableOptions: {
          filterable: true,
          headings: {
            priority_id: 'Prioritet',
            communityName: 'Zajednica',
            title: 'Naslov',
            description: 'Opis',
            current_status: 'Status',
            privacy: 'Privatnost'
          },
          texts: {
            filter: '',
            filterPlaceholder: 'Pretraži',
            count: '',
            noResults: 'Ne postoje tiketi'
          },
          sortable: ['priority_id', 'current_status', 'privacy'],
          perPage: 8
        }
      },
      showDeleteContactModal: false,
      deleteLoading: false,
      contactToDelete: null
    };
  },
  computed: {
    ...mapState(['loading']),
    ...mapState('table', ['tableColumns', 'tableData', 'tableOptions']),
    ...mapState('modal', ['contractor'])
  },
  async created() {
    try {
      this.loadingBasicInfo = true;
      await this.getContractor(this.$route.params.contractorId);
      this.loadingBasicInfo = false;
    } catch (error) {
      console.log(error);
      if (error.response.status == 404) {
        this.$router.push('/notFound');
      } else {
        console.log(error);
        this.showFailModal();
        this.back();
      }
    }
    // console.log('route', this.$route.params.contractorId);
  },
  methods: {
    ...mapMutations(['cardOpened']),
    ...mapMutations('table', ['setTableData']),
    ...mapActions('modal', ['showSuccessModal', 'showFailModal']),
    ...mapMutations('modal', [
      'showModal',
      'setContractor',
      'setContractorContact'
    ]),
    ...mapActions('table', ['getContractor']),
    isValidWebsite(address) {
      return address.startsWith('http');
    },
    // async getContractor() {
    //   this.loadingBasicInfo = true;
    //   const result = await axios.get(
    //     `/contractor/${this.$route.params.contractorId}`
    //   );
    //   result.data.contractor.contacts = result.data.contractor.contacts.map(
    //     contact => {
    //       contact.isExpanded = false;
    //       return contact;
    //     }
    //   );
    //   // this.contractor = result.data.contractor;
    //   // this.setContractor(this.contractor);
    //   // Object.assign(this.contractor, this.$store.state.modal.contractor);

    //   this.setContractor(result.data.contractor);
    //   const tickets = await axios.get(
    //     `contractor/${this.contractor.id}/tickets`
    //   );
    //   const allCommunties = this.$store.getters.getCommunitiesImploded;
    //   const structuredTickets = tickets.data.data.map(t => {
    //     t.dataType = 'ticket-contractor';
    //     t.communityName = '/';
    //     const community = allCommunties.find(c => c.id == t.community_id);
    //     if (community) {
    //       t.communityName = community.name;
    //     }
    //     return t;
    //   });
    //   this.contractor.tickets = structuredTickets;

    //   this.loadingBasicInfo = false;
    // },
    back() {
      this.$router.back();
    },
    toggleItems(contact) {
      contact.isExpanded = !contact.isExpanded;
      //   this.contractor.contacts = [...this.contractor.contacts];
    },
    isExpanded(contact) {
      if (contact.isExpanded) {
        return contact.isExpanded;
      }
      return false;
    },
    openAddContractorContact() {
      this.setContractor(this.contractor);
      this.showModal('ModalContentAddContractorContact');
    },
    openDeleteContact(contact) {
      this.contactToDelete = contact;
      this.showDeleteContactModal = true;
    },
    openEditContact(contact) {
      this.setContractorContact(contact);
      this.showModal('ModalContentEditContractorContact');
    },
    async deleteContractorContact() {
      try {
        this.deleteLoading = true;
        await axios.delete(`contractor/contact/${this.contactToDelete.id}`);
        await this.getContractor(this.$route.params.contractorId);
        this.deleteLoading = false;
        this.showSuccessModal();
        this.showDeleteContactModal = false;
      } catch (error) {
        console.log(error);
        console.log(error);
        this.deleteLoading = false;
        this.showFailModal();
      }
    }
  }
};
</script>
<style lang="scss">
.table-contractor-tickets table tr {
  cursor: pointer !important;
  td:nth-child(4) {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 200px;
  }
}
</style>
<style lang="scss" scoped>
.main-title {
  justify-content: space-between;
  align-items: center;
  .fa-pen {
    color: var(--primary-color);
    cursor: pointer;
  }
}
.header-contractor {
  margin-bottom: 40px;
  .badge--mod {
    position: absolute;
    right: 0;
    left: unset;
    border-radius: 50%;
    padding: 5px;
    margin-right: 10px;
  }
}
.transactions-table {
  tr {
    cursor: default !important;
  }
}
.invoice-date {
  background: none !important;
  font-size: 0.8rem;
  font-weight: 800;
}
.box {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0), 0 2px 15px rgba(0, 0, 0, 0.24);
  margin-bottom: 1rem;
  padding: 16px;
  position: relative;
  .title-wrapper .btn {
    margin-right: 4px;
  }
  .parent {
    .actions {
      padding-right: 0 !important;
    }
  }
  &.contacts .rows .row.expanded-content {
    &:not(:last-child) {
      margin-bottom: 10px;
    }
    .parent {
      border-bottom: 1px solid #cecece;
      padding-bottom: 6px;
      margin-bottom: 8px;
      .actions {
        padding-right: 0;
      }
    }
    .items {
      padding-left: 1%;
      .column {
        margin-bottom: 2px;
      }
    }
  }
}

.title-wrapper {
  margin-bottom: 12px;
  .title {
    font-size: 1.2rem;
    color: black;
    padding-bottom: 4px;
    border-bottom: 1px solid var(--primary-color);
  }

  .btn {
    color: var(--primary-color);
    background: #e6e6e6;
    padding: 2px 5px;
    font-size: 0.9rem;
    float: right;
    margin-right: 14px;
    &:hover {
      background: rgb(210, 210, 210);
    }
  }

  .icons-wrapper {
    display: inline-block;
    margin-left: auto;
    font-size: 1.4rem;
    i {
      padding: 7px 5px;
    }
    .box-icon {
      // position: absolute;
      // top: 0.8rem;
      // right: 0.8rem;
      color: var(--primary-color);
    }
    .invite-members-icon {
      background-color: #e6e6e6;
      padding: 7px 5px;
      border-radius: 5px;
      transition: background-color 0.2s;
    }

    .invite-members-icon:hover {
      background-color: #d2d2d2;
      cursor: pointer;
    }

    .icon-notice {
      color: #d2d2d2;
      transition: color 0.2s;
    }

    .icon-notice:hover {
      color: #dc3546;
      cursor: pointer;
    }

    .icon-default {
      color: #d2d2d2;
      transition: color 0.2s;
    }

    .icon-default:hover {
      color: var(--primary-color);
      cursor: pointer;
    }
  }
}

.body-wrapper {
  display: flex;
  height: 100%;
  .left-column {
    flex: 1;
    height: 100%;
    .info-box {
      width: 100%;
      // border: 1px solid var(--primary-color);
      border-radius: 4px;
      display: flex;
      align-items: flex-end;
      // padding: 8px 8px 8px 0;
      padding: 0;
      .left-column {
        flex: 5;
        display: flex;
        flex-direction: column;
      }
      .right-column {
        flex: 3;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-end;
      }

      .single-info {
        // margin-left: 8px;
        // border: 1px solid black;
        display: flex;
        flex-direction: column;
        padding-top: 2px;
        margin-bottom: 2px;
        &.balance {
          &.positive {
            .value {
              color: var(--primary-color);
            }
          }
          &.negative {
            .value {
              color: rgba(220, 53, 70, 1);
            }
          }
          small {
            text-align: right;
          }
        }
      }

      h2,
      h4 {
        padding: 0;
        margin: 0;
        word-break: break-word;
      }
    }
    .invoices {
      width: 100%;
      height: calc(100% - 220px);
    }
  }
  .right-column {
    flex: 2;
    margin-left: 1rem;
  }
  .table {
    margin-bottom: 0;
    font-size: 0.9rem;
    position: relative;
    z-index: 0;
    height: calc(100% - 30px);

    .right-padding {
      .column:last-of-type {
        padding-right: 0.7rem;
      }
    }

    .rows {
      max-height: calc(100% - 30px);
      overflow-y: auto;

      .row {
        width: 100% !important;
        display: flex;
        flex-direction: column;
        align-items: flex-end;

        .parent {
          padding: 3px 0;
          width: 100%;
          display: flex;
        }

        .more-btn {
          cursor: pointer;
          i {
            transform: rotate(0);
            transition: transform 0.2s;
          }
        }

        .items {
          display: none;
          width: 90%;
          flex-direction: column;
          .row {
            display: flex;
            flex-direction: row;
            background: rgb(240, 240, 240);
            padding-left: 6px;
            border-radius: 4px;
            margin-bottom: 2px;
          }
          .row-desc {
            font-weight: bold;
          }
          .column {
            word-break: break-word;
          }
        }

        &.expanded-content {
          .items {
            display: flex;
          }
          .more-btn {
            i {
              transform: rotate(90deg);
            }
          }
        }

        .column {
          text-align: left;
          display: flex;
          align-items: center;
        }
      }
    }
    .labels {
      border-bottom: 1px solid gray;
      .column {
        font-weight: 600;
      }
    }
    .actions {
      display: flex;
      justify-content: flex-end;
      padding-right: 10px;
      .btn {
        background: rgb(230, 230, 230);
        margin: 0 4px;
        height: 24px;
        width: 24px;
        padding: 0 0 2px 2px;
        position: relative;
        &:hover {
          background: rgb(210, 210, 210);
        }
        i {
          font-size: 0.9rem;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          color: var(--primary-color);
        }
      }
    }
  }
}
.email-field {
  margin: 3px 0;
}
.email-subject {
  margin-bottom: 5px;
}

.flex {
  display: flex;
}

.upload-area {
  margin-top: 5px;
  padding: 5px 0;

  .no-files {
    padding: 0 5px;
  }
  .uploaded {
    background-color: rgb(241, 241, 241);
    border-radius: 4px;
  }
  .file {
    border-bottom: solid 1px lightgray;
    font-size: 15px;
    width: 100%;
    display: inline-flex;
    align-items: center;
    padding: 0 5px;
    p {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      padding-right: 8px;
      margin-bottom: 2px;
    }

    .del--mod {
      margin-left: auto;

      cursor: pointer;
      color: red;
    }
  }
}
</style>
